import { createStore } from 'vuex'

export const dataStock = createStore({
  state: () => {
    return {
      eventsCollect: [],
      buttonDisabled: false,

      data: {
        carousel: [],
        mainDesc: null,
        mainEvent: null,
        highlights: {
          first: {
            title: null,
            desc: null,
            image: null,
            selectedFileName: null
          },
          second: {
            title: null,
            desc: null,
            image: null,
            selectedFileName: null
          },
          third: {
            title: null,
            desc: null,
            image: null,
            selectedFileName: null
          }
        },
        loginImage: null
      }
    }
  },
  getters: {
    getEventsCollect: state => state.eventsCollect,
    getStateForButton: state => state.buttonDisabled
  },
  mutations: {
    SET_EVENTS_COLLECT (state, val) {
      state.eventsCollect = []
      state.eventsCollect = val
    },
    SET_DISABLE_BUTTON (state, val) {
      state.buttonDisabled = val
    }
  },
  actions: {
    setEventsCollect ({ commit }, payload) {
      commit('SET_EVENTS_COLLECT', payload)
    },
    setUploadFile ({ commit }, payload) {
      commit('SET_DISABLE_BUTTON', payload)
    }
  }
})
